import { createContext, useContext, useReducer  } from 'react'
import { randomString } from '../utilities/helpers.js'
import { defaultErrorMessage } from '../utilities/constants.js'

const ToasterContext = createContext()

const useToaster = () => {
    const context = useContext(ToasterContext)

    if (context === undefined) throw new Error('useToaster must be used within a ToasterProvider')

    return context
}

const ToasterProvider = ({ children }) => {
    const reducer = (state, { action, type, text, id, duration }) => {
        switch (action) {
            case 'add': {
                const toastId = randomString()
                setTimeout(() => remove(toastId), duration || 4000)

                return [ ...state, { id: toastId, type, text } ]

                break
            }
            case 'remove': {
                return state.filter((toast) => toast.id !== id )

                break
            }
        }
    }

    const [$state, dispatch] = useReducer(reducer, [])

    const remove = (id) => dispatch({ action: 'remove', id })
    const toast = ({ type = 'info', text, options = {} }) => dispatch({ action: 'add', type, text, ...options })
    const error = (error, options = {}) => toast({ type: 'error', text: error?.response?.data?.message || (typeof error?.response?.data === 'string' && error?.response?.data) || (typeof error === 'string' && error) || defaultErrorMessage, options })
    const success = (text, options = {}) => toast({ type: 'success', text, options })
    const info = (text, options = {}) => toast({ type: 'info', text, options })
    const warning = (text, options = {}) => toast({ type: 'warning', text, options })

    return (
        <ToasterContext.Provider value={{ $state, toast, remove, error, success, info, warning }}>
            {children}
        </ToasterContext.Provider>
    )
}

export { useToaster, ToasterProvider }